<template>
  <div class="ddRobotManageList">
    <div class="header">
      <!-- <div class="header-search">
        <el-input
          class="header-search-item"
          placeholder="搜索内容"
          v-model="key"
          clearable
          @keyup="getSearch()"
          ><i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="getSearch()"
          ></i
        ></el-input>

        <el-select v-model="type" placeholder="类别" class="header-search-item">
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div> -->
      <el-button type="primary" @click="operateModule()">新增</el-button>
    </div>
    <div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="群名称" :align="alignType">
        </el-table-column>
        <el-table-column prop="webhook" label="Webhook" :align="alignType">
        </el-table-column>
        <el-table-column prop="secret" label="密钥" :align="alignType">
        </el-table-column>
        <el-table-column label="操作" :align="alignType">
          <template slot-scope="scope">
            <el-button type="text" @click="operateModule(scope.row, 'edit')"
              >编辑</el-button
            >
            <el-popconfirm
              confirm-button-text="确认"
              cancel-button-text="取消"
              icon="el-icon-info"
              icon-color="red"
              title="是否确认删除该消息模板？"
              @confirm="deleteRow(scope.row.id)"
            >
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          layout="total,prev, pager, next, sizes, jumper"
          :current-page.sync="pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :total="totalRecord"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      width="25%"
      class="ddRobot-dialog"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="messageForm"
        :label-width="formLabelWidth"
      >
        <el-form-item label="群名称" prop="name">
          <el-input
            v-model="form.name"
            type="text"
            autocomplete="off"
            placeholder="请输入"
            rows="5"
          ></el-input>
        </el-form-item>
        <el-form-item label="Webhook" prop="content">
          <el-input
            type="text"
            v-model="form.content"
            autocomplete="off"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="密钥" prop="secret">
          <el-input
            type="text"
            v-model="form.secret"
            autocomplete="off"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>

      <div>
        注：请先在钉钉群中创建智能群机器人，并将Webhook、密钥复制到这里。错误的Webhook、密钥将会导致消息发送失败
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('messageForm')">取 消</el-button>
        <el-button type="primary" @click="addOrEdit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRobotInfoByPage,
  addRobotInfo,
  updateRobotInfo,
  deleteRobotInfo
} from '@api/ddRobotManage'
export default {
  name: 'DdRobotManageList',
  data() {
    return {
      key: '',
      type: '',
      totalRecord: 0,
      pageNum: 1,
      pageSize: 10,
      typeOptions: [],
      dialogFormVisible: false,
      dialogTitle: '新增',
      tableData: [],
      form: {
        id: '',
        name: '',
        type: '',
        content: ''
      },
      alignType: 'center',
      formLabelWidth: '100px',
      rules: {
        name: [
          {
            required: true,
            message: '请输入群名称',
            trigger: 'blur'
          }
        ],
        content: [
          {
            required: true,
            message: '请输入Webhook',
            trigger: 'blur'
          }
        ],
        secret: [
          {
            required: true,
            message: '请输入密钥',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.getSearch()
  },
  methods: {
    // 操作弹框
    operateModule(row, type) {
      this.dialogFormVisible = true
      if (type == 'edit') {
        this.dialogTitle = '编辑'
        const { id, name, webhook, secret } = row
        this.form = { id, name, content: webhook, secret }
      } else {
        this.form = { id: '', name: '', content: '', secret: '' }
        this.dialogTitle = '新增'
      }
    },
    // 删除项
    deleteRow(id) {
      deleteRobotInfo({ id }).then((res) => {
        const { code, msg } = res.data
        if (code === '0000') {
          this.$message({
            message: msg,
            type: 'success'
          })
          this.getSearch()
        }
      })
    },
    // 新增编辑项
    addOrEdit() {
      this.$refs.messageForm.validate((valid) => {
        if (valid) {
          let params
          let url
          if (this.dialogTitle === '编辑') {
            url = updateRobotInfo
            params = {
              id: this.form.id,
              name: this.form.name,
              webhook: this.form.content,
              secret: this.form.secret
            }
          } else {
            url = addRobotInfo
            params = {
              name: this.form.name,
              webhook: this.form.content,
              secret: this.form.secret
            }
          }

          url(params).then((res) => {
            const { code, msg } = res.data
            if (code === '0000') {
              this.resetForm('messageForm')
              this.$message({
                message: msg,
                type: 'success'
              })
              this.getSearch()
            }
          })
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.dialogFormVisible = false
    },
    // 列表搜索
    getSearch() {
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      getRobotInfoByPage(params).then((res) => {
        const { code, data } = res.data
        if (code === '0000') {
          this.tableData = data.results
          this.totalRecord = data.totalRecord
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getSearch()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
.ddRobotManageList {
  background: #fff;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  padding: 20px;
  .header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
    &-search {
      display: flex;
      &-item {
        margin-right: 20px;
      }
      /deep/.el-input__inner {
        width: 240px;
      }
    }
  }
  .el-table {
    /deep/.el-button {
      margin-right: 10px;
    }
  }
  .table-page {
    margin: 20px 0;
    text-align: right;
  }
}
.ddRobot-dialog {
  /deep/.el-dialog__body {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }
}
</style>
